import React from 'react';
import { AdminDashboardSectionShimmer } from '../common/Shimmer.jsx';
import './AdminHealthCheck.css';

const STATUS_LABELS = {
  healthy: '正常',
  degraded: '警告',
  down: '異常',
  unconfigured: '未設定',
  pending: '未実行',
};

function formatCheckedAt(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });
}

/**
 * ダッシュボード用ヘルスチェックサマリー（詳細画面への導線付き）
 */
const DashboardHealthSummary = ({ report, loading, error, onOpenDetail }) => {
  const summary = report?.summary || {
    total: 0,
    healthy: 0,
    degraded: 0,
    down: 0,
    unconfigured: 0,
    pending: 0,
  };

  const checkedAt = formatCheckedAt(report?.checkedAt);
  const hasIssue = summary.down > 0 || summary.degraded > 0;

  return (
    <section className="dashboard-health-section">
      <div className="dashboard-health-header">
        <div>
          <h3>ヘルスチェック</h3>
          <p className="dashboard-health-subtitle">
            {checkedAt ? `最終確認: ${checkedAt}` : '保存済み結果を表示中'}
            {report?.source === 'catalog-only' ? '（初回チェック待ち）' : ''}
          </p>
        </div>
        <button type="button" className="btn btn-secondary btn-sm" onClick={onOpenDetail}>
          詳細を見る
        </button>
      </div>

      {error && <div className="health-check-error">{error}</div>}

      {loading && !report ? (
        <AdminDashboardSectionShimmer cards={5} />
      ) : (
        <div className="health-summary-grid dashboard-health-summary-grid">
          <div className="health-summary-card total">
            <div className="label">合計</div>
            <div className="value">{summary.total}</div>
          </div>
          <div className="health-summary-card healthy">
            <div className="label">{STATUS_LABELS.healthy}</div>
            <div className="value">{summary.healthy}</div>
          </div>
          <div className="health-summary-card degraded">
            <div className="label">{STATUS_LABELS.degraded}</div>
            <div className="value">{summary.degraded}</div>
          </div>
          <div className="health-summary-card down">
            <div className="label">{STATUS_LABELS.down}</div>
            <div className="value">{summary.down}</div>
          </div>
          <div className="health-summary-card unconfigured">
            <div className="label">{STATUS_LABELS.unconfigured}</div>
            <div className="value">{summary.unconfigured}</div>
          </div>
          {(summary.pending ?? 0) > 0 && (
            <div className="health-summary-card pending">
              <div className="label">{STATUS_LABELS.pending}</div>
              <div className="value">{summary.pending}</div>
            </div>
          )}
        </div>
      )}

      {hasIssue && !loading && (
        <p className="dashboard-health-alert">
          警告または異常のターゲットがあります。詳細画面で確認してください。
        </p>
      )}
    </section>
  );
};

export default DashboardHealthSummary;
